import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Panel, Row, Col, Alert, FormGroup, Checkbox } from 'react-bootstrap'
import Input from '../components/elements/input'
import * as _ from 'lodash'
import autobind from 'autobind-decorator'
import { reduxForm, getValues, change as changeFieldValue } from 'redux-form'
import GuestInfoForm from '../components/guestInfoForm'
import PricePanel from '../components/pricePanel'
import {
  preparePayment,
  findLocalRooms,
  histGuestEntryPage,
  startHoldTimer,
  resetGuestRoomNames,
  resetRoomBookingState,
  initRoomPrices,
  changeBookingStatus,
  flaggedContactDialogContinueBooking,
  flaggedContactDialogReset
} from '../redux/actions'
import { hiddenFields, STATE_ELIGIBLE_GUESTENTRY } from '../constants'
import {
  getRoomsList,
  getFieldsFromCache,
  getObjFromCache,
  getGuestInitFields,
  gotoSearchPage,
  setGuestFormFieldsToCache
} from '../redux/stateUtils'
import {
  getObjVal,
  isEmpty,
  getFromCache,
  getRoomDisplayNameForGuestEntry
} from '../utils'
import { guestEntryFields, defaultPayingGuestValue } from '../redux/formSchema'
import RoomBookNavTabs from '../components/roomBookNavTabs'
import BottomNavigationButtons from './bottomNavigationButtons'
import FlaggedContactModal from '../components/modals/FlaggedContactModal'
import CheckInOutDates from '../components/checkInOutDates'
import { resetErrorValues } from '../redux/modules/errorDialogModule'
import {
  numDaysSelector,
  programSelector,
  roomSearchParamsSelector
} from '../redux/modules/searchParamsModule'
import { getPriceFromSelections } from '../logic/pricingLogic'
import { getNumGuestsFromRoomField } from '../redux/modules/roomSelectionFormModule'
import { shouldCollectGuestInformation } from '../logic/guestLogic'
import { validateNumAdultsChildren } from '../redux/modules/guestEntryFormModule'
import history from '../history'

@autobind
class GuestEntry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      totalPayment: 0,
      selectedRooms: []
    }
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    rooms: PropTypes.object.isRequired,
    searchParams: PropTypes.object.isRequired,
    fields: PropTypes.any.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    payment: PropTypes.object.isRequired,
    auth: PropTypes.object,
    value: PropTypes.any
  }

  handleNextClick(formData) {
    let { dispatch } = this.props
    return dispatch(validateNumAdultsChildren(formData)).then(
      () => {
        dispatch(changeBookingStatus('GE_COMPLETED'))
        dispatch(preparePayment(formData, this.state.totalPayment))
      },
      error => {
        window.scrollTo(0, 0)
        return Promise.reject(error)
      }
    )
  }

  // Updates the custom price field for the given room object
  restoreCustomPrice(value, listingIndex, roomIndex) {
    this.props.dispatch(
      changeFieldValue(
        'roomSelection',
        'listings[' + listingIndex + '].rooms[' + roomIndex + '].customPrice',
        parseInt(value)
      )
    )
  }

  // For each room: Based on changes to useCustomPrice checkbox field, this will update the customPrice input field
  reviseCustomPriceCheckBox(onChange, value, listingIndex, roomIndex) {
    onChange(value)
    if (value && !value.target.checked) {
      this.restoreCustomPrice(0, listingIndex, roomIndex)
    }
  }

  // For each room: This will update the customPrice input field default value
  updateCustomPriceField(onChange, value, listingIndex, roomIndex) {
    onChange(value)
    if (value && value.target.value !== 0) {
      this.restoreCustomPrice(value.target.value, listingIndex, roomIndex)
    }
  }

  handlePrevBtn(event) {
    gotoSearchPage(event, this.props.location, this.props.dispatch)
  }

  getPricePanel(rooms) {
    const {
      numDays,
      fields: { listings, guestDetails },
      history: { prevPage },
      auth: { authenticated },
      roomPrices,
      dispatch,
      program
    } = this.props

    const paymentAmount = getPriceFromSelections(
      roomPrices,
      getValues(listings),
      rooms,
      prevPage,
      true,
      guestDetails,
      dispatch,
      program
    )

    this.state.totalPayment = paymentAmount * numDays
    let roomsCustomPayment = authenticated
      ? _.flatMap(listings, (listingField, listingIndex) => {
          return _.map(listingField.rooms, (roomField, roomIndex) => {
            if (roomField && roomField.roomId && getObjVal(roomField.roomId)) {
              return (
                <Row>
                  <FormGroup>
                    <Checkbox
                      {...roomField.useCustomPrice}
                      value={
                        getObjVal(roomField.useCustomPrice)
                          ? getObjVal(roomField.useCustomPrice)
                          : false
                      }
                      onChange={value => {
                        this.reviseCustomPriceCheckBox(
                          roomField.useCustomPrice.onChange,
                          value,
                          listingIndex,
                          roomIndex
                        )
                      }}
                      style={{ float: 'left' }}
                    >
                      {rooms[getObjVal(roomField.roomId)].name +
                        ' Custom Price'}
                    </Checkbox>
                  </FormGroup>

                  <Input
                    {...getObjVal(roomField.customPrice)}
                    value={
                      getObjVal(roomField.useCustomPrice)
                        ? getObjVal(roomField.customPrice)
                        : 0
                    }
                    type='number'
                    onChange={value => {
                      this.updateCustomPriceField(
                        roomField.customPrice.onChange,
                        value,
                        listingIndex,
                        roomIndex
                      ) // onChange
                    }}
                    standalone
                    style={{ float: 'left' }}
                    disabled={
                      getObjVal(roomField.useCustomPrice) &&
                      getObjVal(roomField.useCustomPrice)
                        ? undefined
                        : true
                    }
                  />
                </Row>
              )
            }
          })
        })
      : ''
    return (
      <div className='checkin-price-panels'>
        <Panel>
          <PricePanel numDays={numDays} pricePerDay={paymentAmount} />
          <Col md={12}>{roomsCustomPayment}</Col>
        </Panel>
      </div>
    )
  }

  getCheckInOutDates() {
    let {
      searchParams: { checkInDate, checkOutDate }
    } = this.props
    return (
      <CheckInOutDates checkInDate={checkInDate} checkOutDate={checkOutDate} />
    )
  }

  // Gets the guest entry details form to display in Guest details page
  getInfoGuestInfo(commonGuestFields, roomList, payingGuest) {
    let {
      fields: { guestDetails },
      rooms,
      dispatch
    } = this.props
    let { selectedRooms } = this.state

    return (
      <GuestInfoForm
        selectedRooms={selectedRooms}
        authenticated={this.props.auth.authenticated}
        totalGuests={1}
        roomGender=''
        rooms={rooms}
        dispatch={dispatch}
        commonGuestFields={commonGuestFields}
        roomList={roomList}
        payingGuest={payingGuest}
        guestDetails={guestDetails}
      />
    )
  }

  componentDidMount() {
    let { dispatch } = this.props
    window.scrollTo(0, 0)
    dispatch(changeBookingStatus('GE_PROCESSING'))
  }

  componentWillReceiveProps(nextProps) {
    let { selectedRooms } = this.state
    setGuestFormFieldsToCache(nextProps, selectedRooms)
  }

  componentWillUnmount() {
    let { dispatch } = this.props

    // sets the pages history in state object
    dispatch(histGuestEntryPage())
  }

  componentWillMount() {
    let {
      dispatch,
      history: { prevPage },
      fields: { guestDetails },
      roomPrices,
      searchResults,
      bookingDetails: { currentState }
    } = this.props
    let fieldsObj = getFieldsFromCache()
    let resultEmpty = !searchResults || searchResults.length === 0
    let formEmpty =
      !fieldsObj ||
      !fieldsObj.guestDetails ||
      fieldsObj.guestDetails.length === 0
    if (prevPage === '') {
      dispatch(findLocalRooms())
    }
    let statesEligibleGuestEntry = STATE_ELIGIBLE_GUESTENTRY
    if (statesEligibleGuestEntry.indexOf(currentState) !== -1) {
      if (resultEmpty && formEmpty) {
        // When the direct guestentry url is entered by the user,
        // then it redirects to the search page
        this.props.histroy.push('/search')
      } else {
        if (prevPage !== 'PAYMENT' && prevPage !== '') {
          dispatch(resetGuestRoomNames(guestDetails))
        }
        dispatch(resetErrorValues({}))
        let holds = localStorage.getItem('holds')
        var path = this.props.location.pathname
        // Checks and loads the form values from local history if page is refreshed
        if (
          !isEmpty(holds) &&
          prevPage !== 'RESULTS' &&
          prevPage !== 'PAYMENT' &&
          path === '/guestentry'
        ) {
          dispatch(startHoldTimer())
        }
        if (!roomPrices || roomPrices.length === 0) {
          this.props.dispatch(
            initRoomPrices(() => {
              this.forceUpdate()
            })
          )
        }
        if (!isEmpty(holds) && prevPage === 'RESULTS') {
          this.populateSelectedRoomsInState(true)
        }
      }
    } else {
      // When the direct guestentry url is entered by the user when in results page,
      // then it redirects to the results page
      history.push('/results')
    }
  }

  populateSelectedRoomsFromCache() {
    let selectedRoomsFromCache = getFromCache('selectedRooms')
    if (selectedRoomsFromCache) {
      this.state.selectedRooms = selectedRoomsFromCache
    }
  }

  populateSelectedRoomsInState(resetGuests) {
    let {
      history: { prevPage },
      fields: { listings, guestDetails },
      auth: { authenticated },
      dispatch,
      rooms
    } = this.props
    let { selectedRooms } = this.state
    let guestCount = 0
    let roomIdsList = []
    let repeatedRoomsCount = {}

    // Iterate over rooms in roomSelection form (listings object)
    _.flatMap(listings, (listingField, listingIndex) => {
      _.map(listingField.rooms, (roomField, roomIndex) => {
        if (roomField && roomField.roomId && getObjVal(roomField.roomId)) {
          let roomObject = rooms[getObjVal(roomField.roomId)]
          let displayName = getRoomDisplayNameForGuestEntry({
            room: roomObject,
            authenticated
          })
          const numGuestsInRoom = getNumGuestsFromRoomField(roomField)

          let obj = {
            roomId: getObjVal(roomField.roomId),
            displayName: displayName,
            numberOfGuests: numGuestsInRoom,
            guestsIndxs: [],
            cacheGuestCount: 0
          }

          _.times(getNumGuestsFromRoomField(roomField), guestCountIdx => {
            obj.guestsIndxs.push({ ordIndex: -1 })
          })

          if (repeatedRoomsCount[displayName]) {
            repeatedRoomsCount[displayName]['rooms'].push(
              getObjVal(roomField.roomId)
            )
          } else {
            repeatedRoomsCount[displayName] = {
              rooms: [getObjVal(roomField.roomId)],
              count: 1
            }
          }

          guestCount += numGuestsInRoom
          selectedRooms.push(obj)

          roomIdsList.push(getObjVal(roomField.roomId))
        }
      })
    })

    // Below logic to append the number to the room name to indicate that
    // guest user is filling the details for separate room
    _.flatMap(selectedRooms, (room, roomIndex) => {
      let roomObject = rooms[getObjVal(room.roomId)]
      let displayName = getRoomDisplayNameForGuestEntry({
        room: roomObject,
        authenticated
      })
      let repeatedRoom = repeatedRoomsCount[displayName]
      if (repeatedRoom.rooms.length > 1) {
        room.displayName = room.displayName + '(' + repeatedRoom.count + ')'
        repeatedRoom.count++
      }
    })

    if (resetGuests) {
      let guestIndexesNeedsToRemove = []
      let notRemovedCount = 0
      // To remove the added guest fields and freshly insert the guest fields
      _.times(guestDetails.length, index => {
        if (isEmpty(getObjVal(guestDetails[index].room))) {
          guestIndexesNeedsToRemove.push(index)
          // guestDetails.removeField(index)
        } else {
          let currentRoom = _.find(selectedRooms, room => {
            return room.roomId === getObjVal(guestDetails[index].room)
          })
          if (currentRoom) {
            if (prevPage !== 'PAYMENT' && prevPage !== '') {
              if (selectedRooms.length === 1) {
                this.setDefaultValuesForSingleRoom(rooms, selectedRooms, index)
              } else {
                guestDetails[index].room = ''
              }
            }
            notRemovedCount++
          } else {
            guestIndexesNeedsToRemove.push(index)
            console.log(
              '---Removing since there is no matching room available in cache:: ',
              getObjVal(guestDetails[index].room),
              guestDetails
            )
          }
        }
      })

      _.sortBy(guestIndexesNeedsToRemove)
        .reverse()
        .forEach(guestIndex => {
          guestDetails.removeField(guestIndex)
        })

      if (guestCount - notRemovedCount >= 0) {
        _.times(guestCount - notRemovedCount, indx => {
          guestDetails.addField()
          if (selectedRooms.length === 1) {
            this.setDefaultValuesForSingleRoom(
              rooms,
              selectedRooms,
              notRemovedCount + indx
            )
          }
        })
      } else {
        _.times(notRemovedCount - guestCount, indx => {
          guestDetails.removeField()
        })
      }
    }

    if (selectedRooms.length > 0) {
      // Setting the default value of age value to adult for paying guest
      dispatch(
        changeFieldValue('roomSelection', 'guestDetails[0].guestType', 'adult')
      )
    }
  }

  setDefaultValuesForSingleRoom(availableRooms, selectedRooms, index) {
    let { dispatch } = this.props
    let selectedRoom = availableRooms[getObjVal(selectedRooms[0].roomId)]
    // Setting the default value of room dropdown, when there is only one room selected
    dispatch(
      changeFieldValue(
        'roomSelection',
        'guestDetails[' + index + '].room',
        selectedRooms[0].roomId
      )
    )
    // Setting the default value of gender dropdown, when there is only one room selected
    if (selectedRoom.gender !== 'none') {
      dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + index + '].gender',
          selectedRoom.gender
        )
      )
    }
    // Setting the default value of age dropdown to adult, if childrensAllowed is false
    if (!selectedRoom.childrensAllowed) {
      dispatch(
        changeFieldValue(
          'roomSelection',
          'guestDetails[' + index + '].guestType',
          'adult'
        )
      )
    }
  }

  render() {
    let {
      handleSubmit,
      rooms,
      dispatch,
      auth: { authenticated, level },
      fields: { commonGuestFields, listings, payingGuest },
      formErrors: { messages },
      error,
      errors,
      flaggedContact
    } = this.props
    if (this.state.selectedRooms.length === 0) {
      this.populateSelectedRoomsFromCache()
    }
    let roomList = getRoomsList(listings, rooms)

    let errorMessages = []
    let errorsToShow = []
    let reqErrorMsg = 'Please fill in all required fields'
    if ((this.props.submitFailed && !this.props.valid) || messages) {
      if (error) {
        errorsToShow.push(error)
      }

      if (!_.isEmpty(errors)) {
        errorsToShow.push(reqErrorMsg)
      }

      errorMessages = _.flatMap(
        _.filter(_.uniq([...errorsToShow, ...messages])),
        message => {
          return <Alert bsStyle='danger'>{message}</Alert>
        }
      )
    }
    let guestInfoHtml = this.getInfoGuestInfo(
      commonGuestFields,
      roomList,
      payingGuest
    )
    return (
      <div>
        {' '}
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <RoomBookNavTabs {...this.props} />
              </Col>
            </Row>
            <Row>
              <Panel id='guest_entry_form'>
                <Row>
                  <Col md={9}>{errorMessages}</Col>
                </Row>
                <Row>
                  <Col sm={9}>
                    {/* TODO: refactor method to call without params */}
                    {guestInfoHtml}
                  </Col>
                  <Col sm={3}>
                    <div className='pricePanels'>
                      <div>{this.getCheckInOutDates()}</div>
                      <div>{this.getPricePanel(rooms, listings)}</div>
                    </div>
                  </Col>
                </Row>
              </Panel>
            </Row>
          </Col>
        </Row>
        <BottomNavigationButtons
          {...this.props}
          showBack
          showNext
          nextCB={handleSubmit(this.handleNextClick)}
          backCB={this.handlePrevBtn}
          customClass='guest-entry-navigation'
        />
        {flaggedContact.showDialog ? (
          <FlaggedContactModal
            accessType={
              authenticated ? (level === 3 ? 'admin' : 'user') : 'guest'
            }
            contact={flaggedContact.contact}
            onContinueClick={() => {
              dispatch(flaggedContactDialogContinueBooking())
              // handleSubmit returns a function
              handleSubmit(this.handleNextClick)()
            }}
            onExitBookingClick={() => {
              dispatch(flaggedContactDialogReset())
              dispatch(resetRoomBookingState())
              this.props.histroy.push('/search')
              dispatch()
            }}
          />
        ) : null}
      </div>
    )
  }
}

let requiredFields = ['visitPurpose', 'volunteerHandlingBooking']
let addressFields = ['street', 'city', 'state', 'zip', 'country']
let guestReqFields = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'gender',
  'room',
  'guestType'
]
let secondaryGuestLoggedInUserReqFields = ['room', 'guestType', 'email']

function validateCommonGuestFields(values, authenticated) {
  let errors = {}
  if (authenticated) {
    requiredFields.forEach(field => {
      if (!getObjVal(values[field]) && hiddenFields.indexOf(field) < 0) {
        errors[field] = 'Required'
      }
    })
  }
  // TODO: add generic code to update the errors from required fields
  errors['address'] = {}
  addressFields.forEach(field => {
    if (
      !getObjVal(values['address'][field]) &&
      hiddenFields.indexOf(field) < 0
    ) {
      errors['address'][field] = 'Required'
    }
  })
  return errors
}

const emailRegex = /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/

// Validates room booking guest entry fields and common fields
function validateListingGuestFields(guests, authenticated) {
  var guestFormErrors = []
  guests.map(function(guest, guestInd) {
    var guestErrors = {}
    if (guestInd === 0) {
      guestReqFields.forEach((field, index) => {
        if (field === 'email' && !emailRegex.test(getObjVal(guest[field]))) {
          guestErrors[field] = 'Not a valid e-mail address'
        }
        if (!getObjVal(guest[field])) {
          guestErrors[field] = 'Required'
        }
      })
    } else {
      if (authenticated) {
        secondaryGuestLoggedInUserReqFields.forEach((field, index) => {
          if (field === 'email') {
            if (
              getObjVal(guest[field]) &&
              !emailRegex.test(getObjVal(guest[field]))
            ) {
              guestErrors[field] = 'Not a valid e-mail address'
            }
          } else if (!getObjVal(guest[field])) {
            guestErrors[field] = 'Required'
          }
        })
      } else {
        guestReqFields.forEach((field, index) => {
          if (
            field === 'email' &&
            getObjVal(guest[field]) &&
            !emailRegex.test(getObjVal(guest[field]))
          ) {
            guestErrors[field] = 'Not a valid e-mail address'
          }
          let isRoomFieldEmpty = field === 'room' && !getObjVal(guest[field])
          let isOtherFieldEmpty =
            field !== 'room' &&
            shouldCollectGuestInformation(guest.guestType) &&
            !getObjVal(guest[field])
          if (isRoomFieldEmpty || isOtherFieldEmpty) {
            guestErrors[field] = 'Required'
          }
        })
      }
    }
    guestFormErrors.push(guestErrors)
  })
  return guestFormErrors
}

function validate(values, state) {
  let {
    auth: { authenticated }
  } = state
  return {
    commonGuestFields: validateCommonGuestFields(
      values.commonGuestFields,
      authenticated
    ),
    guestDetails: validateListingGuestFields(values.guestDetails, authenticated)
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  let rooms = state.rooms
  let roomsFromCache = getObjFromCache('rooms')
  if (Object.keys(rooms).length === 0 && roomsFromCache) {
    rooms = roomsFromCache
  }
  let searchDetails = getObjFromCache('searchDetails')
  let searchResults = state.roomSearch.results
  if (history.prevPage === '' && searchDetails) {
    searchResults = searchDetails.searchResults
  }
  return {
    searchParams: roomSearchParamsSelector(state),
    numDays: numDaysSelector(state),
    rooms: rooms,
    payment: state.payment,
    auth: state.common.authentication,
    history: state.common.history,
    roomPrices: state.common.roomPrices,
    formErrors: state.common.formErrors,
    searchResults: searchResults,
    bookingDetails: state.common.bookingDetails,
    holdStatus: state.roomSearch.holdStatus,
    flaggedContact: state.roomSearch.flaggedContact,
    program: programSelector(state)
  }
}

let reduxFormFunc = reduxForm(
  {
    form: 'roomSelection',
    destroyOnUnmount: false,
    fields: guestEntryFields,
    initialValues: getGuestInitFields(defaultPayingGuestValue),
    validate
  },
  selectProps
)

// Wrap the component to inject dispatch and state into it
export default reduxFormFunc(GuestEntry)



// WEBPACK FOOTER //
// ./src/containers/guestEntry.js